import * as signalR from "@microsoft/signalr";
import { connectSignalrAdvancing } from "../advancing";
import { type AnyAction, type Store } from "redux";
import { onCheatingDetected } from "common/signalR";
import { routes } from "utilities/routing/generatedRoutes";

export const signalRMiddleware = () => (next: any) => (action: any) => next(action);

export const signalRStart = (store?: Store<any, AnyAction>) => {
  const hubConnection = new signalR
    .HubConnectionBuilder()
    .withUrl(site.deploymentValues.signalREndpoint)
    .configureLogging(site.deploymentValues.signalRBrowserDebugLevel)
    .withAutomaticReconnect()
    .build();

  window.signalRConnections = {
    hub: hubConnection
  };

  if (store) {
    connectSignalrAdvancing(store);
  }

  onCheatingDetected(() => {
    window.location.href = routes.account_ReprimandedForCheating().absolute;
  });

  hubConnection.start();
};
